// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7846":"edde2081","7848":"b81e0284"}[chunkId] + ".chunk.css";
};